import { render, staticRenderFns } from "./language-menu.vue?vue&type=template&id=b2adc8a6"
import script from "./language-menu.vue?vue&type=script&lang=js"
export * from "./language-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports